var _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconOpenChat = function SvgIconOpenChat(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_440_1205)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4754,
    cy: 16.5,
    rx: 7.52459,
    ry: 7.5,
    fill: "#97BE7A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_1205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1012 34.4083C46.1012 32.6 45.1679 31.3167 43.5345 30.815C43.5345 30.57 43.5229 30.3133 43.5229 30.0567C43.5229 29.4033 43.5112 28.7267 43.3829 28.0617C42.6129 24.0833 40.2212 21.47 36.2895 20.315C35.8812 20.1983 35.4729 20.14 35.0762 20.0817C34.9012 20.0583 34.7379 20.035 34.5629 20H33.1395L32.9529 20.035C31.9495 20.1167 31.0045 20.3383 30.1529 20.7117C26.9445 22.0883 24.9612 24.5033 24.2379 27.8867C24.0629 28.7383 24.0629 29.5783 24.0629 30.395V30.7217C23.3745 30.7683 22.7212 31.0483 22.2079 31.5383C21.5895 32.1217 21.2162 32.9617 21.1929 33.7783C21.1579 35.4233 21.1579 36.8817 21.1929 38.235C21.2279 39.81 22.4995 41.0933 24.0862 41.1633C24.6812 41.1867 25.2645 41.1867 25.8595 41.1867H26.4895C27.3179 41.1867 27.7962 40.7083 27.7962 39.8683V32.1917C27.7962 32.0633 27.7962 31.935 27.7729 31.8067C27.6795 31.1183 27.2012 30.71 26.5129 30.71H26.4895V30.4533C26.4895 29.8583 26.5012 29.2983 26.5829 28.75C27.0495 25.2617 29.8145 22.6717 33.3262 22.4617C36.0562 22.2983 38.2612 23.395 39.8829 25.7167C40.9795 27.2917 41.1429 29.0767 41.0845 30.71H41.0379C40.4545 30.71 40.0462 31.0133 39.8829 31.5617C39.8245 31.7483 39.8012 31.9467 39.8012 32.18V39.88C39.8012 40.4633 40.0462 40.8717 40.4779 41.0583C39.7312 41.665 38.6929 42.0967 38.0045 42.1317C37.3512 40.2533 35.5195 39.425 34.0262 39.6117C32.0895 39.8567 30.6895 41.42 30.6779 43.3333C30.6779 45.2 32.1245 46.81 34.0495 47.0667C34.2129 47.09 34.3645 47.1017 34.5279 47.1017C36.0562 47.1017 37.4095 46.11 38.0045 44.5467C39.0895 44.4767 40.1045 44.1733 41.0495 43.6367C42.0995 43.0417 42.9395 42.19 43.5695 41.0933C45.2029 40.86 46.1129 39.8217 46.1129 38.165V37.5933C46.1129 36.5317 46.1129 35.47 46.1129 34.42L46.1012 34.4083ZM42.2629 38.7367V33.1717C42.5545 33.1717 42.8462 33.1717 43.0912 33.195C43.1145 33.195 43.2195 33.265 43.3712 33.4517C43.5579 33.685 43.6512 33.9883 43.6512 34.35V38.1767C43.6512 38.585 43.5579 38.69 43.1379 38.7367C43.0679 38.7367 42.9979 38.7367 42.8929 38.7367H42.2629V38.7367ZM25.3345 33.16V38.725C24.9262 38.725 24.5295 38.7367 24.1445 38.7133C23.8529 38.69 23.6312 38.41 23.6312 38.0833C23.6312 36.7067 23.6312 35.3417 23.6312 33.965C23.6312 33.4517 23.9229 33.16 24.4479 33.16H25.3345V33.16ZM35.7412 43.38C35.7412 43.7067 35.6129 44.0217 35.3795 44.2667C35.1345 44.5117 34.8195 44.6517 34.4812 44.6517C33.7579 44.6517 33.1395 44.0217 33.1395 43.31C33.1395 42.61 33.7229 42.0267 34.4345 42.0267C35.1929 42.0267 35.7412 42.5983 35.7412 43.38V43.38Z",
    fill: "#FBFBFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_440_1205",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.286275 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_1205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_1205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_440_1205",
    x: 35.9508,
    y: 0,
    width: 35.0492,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592157 0 0 0 0 0.745098 0 0 0 0 0.478431 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_1205"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_1205",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_1205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(20 20)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOpenChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-open-chat.249c4686.svg";
export { ForwardRef as ReactComponent };